import { get } from 'lodash';

/** Fired after in-memory dispatcher layout changes (e.g. start-time edit) so React calendars re-render. */
export const DISPATCHER_LAYOUT_REFRESH_EVENT = 'dispatcher:layout-refresh';

/** Fired when an order on the board is mutated in place (e.g. estimation saved). */
export const DISPATCHER_ORDER_UPDATED_EVENT = 'dispatcher:order-updated';

export const DISPATCHER_CONSTANTS = {
  DEFAULT_ESTIMATED_DURATION: 3600,
  ESTIMATED_DURATION_UNITS: 'seconds' as const,
  DISPATCHER_OFFSET_UNITS: 'seconds' as const,
  TRAVEL_WINDOW_DURATION: 60,
  TRAVEL_WINDOW_UNITS: 'minutes' as const,
  DEFAULT_TIMES_FROM: 6,
  DEFAULT_TIMES_TILL: 20,
  DISPATCH_OFFSET_INTERVAL: 1800,
  ARRIVAL_WINDOW: get(window, 'clutter.appointment.arrival_window'),
  DEFAULT_WINDOW_SLOT_DURATION: 1800,
  ARRIVAL_VALID_OFFSET: 30,
  BREAK_OFFSET: 270,
  BREAK_OFFSET_UNITS: 'm' as const,
  BREAK_LENGTH: 30,
  BREAK_LENGTH_UNIT: 'm' as const,
};
